import { GET_ORDER_CHARGES } from '../actionTypes/CartActionTypes';

export const getOrderCharges = (payload) => ({
    type: GET_ORDER_CHARGES,
    payload,
});

export default { getOrderCharges };
